import React from 'react';
import Box from '@mui/material/Box';
import Folder from '../Folder';

const Folders = props => {
  const {
    folders,
    setData,
    setError,
    setLoading,
    setInitialData,
    setBreadCrumb,
    setSelectedFilters,
  } = props;

  return (
    <>
      {folders.map(folder => (
        <Box key={folder.id}>
          <Folder
            id={folder.id}
            title={folder.title}
            treeMediaCount={folder.treeMediaCount}
            hasChildren={folder.hasChildren}
            setData={setData}
            setError={setError}
            setLoading={setLoading}
            setInitialData={setInitialData}
            setBreadCrumb={setBreadCrumb}
            setSelectedFilters={setSelectedFilters}
          />
        </Box>
      ))}
    </>
  );
};

export default Folders;
